export const DEPARTURE = "Departure"
export const ARRIVAL = "Arrival"
export const TRANSFER = "Transfer"
export const PICKUP = "Pickup"
